"use strict";
import { makeStyles } from "@mui/styles";
import { theme } from "./ThemeContext/ThemeObject";
export const calendarSharedStyles = makeStyles(() => ({
  meetingContainer: {
    marginTop: 30,
    paddingTop: 10,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    overflow: "scroll",
    marginLeft: "-1%",
    marginRight: "-1%"
  },
  recContainer: {
    display: "flex"
  },
  recImage: {
    borderRadius: "100%",
    width: 45,
    height: 45,
    maxHeight: 45,
    maxWidth: 45,
    background: "#DDDDDD",
    color: "#000",
    fontSize: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  recDetails: {
    marginLeft: 14,
    display: "flex",
    flexDirection: "column",
    "& h4": {
      fontSize: 15,
      color: "#000000",
      fontWeight: 400,
      marginBottom: 4
    },
    "& a": {
      fontWeight: "600",
      color: theme.palette.primary.main,
      textDecoration: "none",
      fontSize: 14,
      lineHeight: "14px"
    }
  }
}));
